module.exports = __webpack_public_path__ + "img/矩形 9.150f8582.png";